import bulmaStyle from '../variables.scss';

export default {
  branding: {
    colors: bulmaStyle,
    font: {
      family: 'Open Sans, sans-serif',
      url: 'https://fonts.googleapis.com/css?family=Open+Sans&display=swap',
    },
  },
};
